import * as palette from "../palette";

interface IDividerProps {
  variant?: "faded" | "fade-to-right" | "normal";
}

export default function Divider({ variant = "normal" }: IDividerProps) {
  if (variant === "fade-to-right") {
    return (
      <div
        aria-hidden={true}
        css={{
          width: "100%",
          height: 1,
          opacity: 0.5,
          backgroundImage: `linear-gradient(to right, rgba(146, 167, 187, 0.4), rgba(0, 0, 0, 0))`,
        }}
      />
    );
  }
  return (
    <div
      aria-hidden={true}
      css={{
        width: "100%",
        height: 1,
        borderBottom: variant === "normal" ? `solid 1px ${palette.mystic}` : undefined,
        opacity: 0.5,
        backgroundImage:
          variant === "faded"
            ? `linear-gradient(to right, rgba(0, 0, 0, 0), ${palette.mystic}, rgba(0, 0, 0, 0))`
            : undefined,
      }}
    />
  );
}
